import React, { useEffect } from 'react';
import { Box, Stack, useTheme } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { reduxHelper } from '../../../config/reduxHelper';
import TextPropertiesPanel from '../../siteBuilder/properties/TextPropertiesPanel';

const FlexibleSpacerBlock = ({ block, isSiteBuilder, isActive, handleUpdate, onDelete, onDuplicate }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { siteBuilderSelectedChild } = useSelector((s) => s.reducer);

    useEffect(() => {
        if (isSiteBuilder && isActive && siteBuilderSelectedChild?.uid !== block.uid) {
            dispatch({
                type: reduxHelper.UPDATE_SITE_BUILDER_SELECTED_CHILD,
                payload: { ...block },
            });
        }
    }, [isActive, isSiteBuilder, block, siteBuilderSelectedChild, dispatch]);

    const outlineColor = theme.palette.info.main;

    return (
        <Box
            sx={{
                position: 'relative',
                width: '100%',
                minHeight: isSiteBuilder ? '20px' : '0px',
                // outline: (isSiteBuilder && isActive) ? `1px solid ${outlineColor}` : 'none',
                // outlineOffset: '-1px',
            }}
        >
            {isSiteBuilder && isActive && (
                <Box
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                    sx={{
                        position: 'absolute',
                        bottom: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        zIndex: 10000,
                        mb: 1
                    }}
                >
                    <TextPropertiesPanel
                        childOverride={block}
                        onChangeChild={(updated) => handleUpdate(updated)}
                        onDeleteChild={() => onDelete && onDelete(block.id)}
                        onDuplicateChild={() => onDuplicate && onDuplicate(block.id)}
                    />
                </Box>
            )}

            <Stack
                sx={{
                    width: block.props?.sx?.width || block.props?.width || '100%',
                    height: block.props?.sx?.height || block.props?.height || block.props?.style?.height || '20px',
                    ...block.props?.sx,
                    bgcolor: 'transparent',
                }}
            />
        </Box>
    );
};

export default FlexibleSpacerBlock;
